{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.66.0",
	"hash": "5b01a444076dd132333de243dc23d5f5f73575a7"
}
